@if (!formGroup.get('guid').value) {
  @if (site()) {
    <div>
      {{ site().name }}
      <p>
        {{ 'notes.siteInfo' | translate }}
      </p>
    </div>
  }
}
@if (!formGroup.get('guid').value) {
  <app-segment-list [segmentValue]="viewSegment()"
    [segmentButtons]="viewSegmentButtons"
    (segmentChanged)="viewSegment.set($event)"></app-segment-list>
}
<form [formGroup]="formGroup">
  @if (viewSegment() === 'text') {
    <app-report-note [text]="noteText()"></app-report-note>
    <div class="ion-margin-top">
      <ion-button color="light"
        (click)="save()">
        <app-loading-button [loading]="loading()">
          {{ 'general.save' | translate }}
        </app-loading-button>
      </ion-button>
      @if (formGroup.get('guid').value) {
        <ion-button color="light"
          (click)="print()">
          {{ 'general.print' | translate }}
        </ion-button>
      }
    </div>
  } @else {
    <ion-item>
      <ion-textarea autocapitalize="on"
        rows="10"
        formControlName="text"></ion-textarea>
    </ion-item>
    <div class="ion-margin-top">
      <ion-button color="light"
        [disabled]="!formGroup.valid"
        (click)="onAi()">
        <app-loading-button [loading]="loading()">
          {{ 'general.next' | translate }}
        </app-loading-button>
      </ion-button>
    </div>
  }
</form>